<p-stepper
  (valueChange)="this.onStepChange()"
  *transloco="let transloco"
  [linear]="this.props.linear !== undefined ? this.props.linear : true"
  [value]="1">
  @if (this.props.orientation === undefined || this.props.orientation === 'horizontal') {
    <p-step-list>
      @for (step of this.field.fieldGroup; track step; let index = $index) {
        <p-step [value]="index + 1">
          <ng-container
            [ngTemplateOutletContext]="{ $implicit: step }"
            [ngTemplateOutlet]="stepTemplate"></ng-container>
        </p-step>
      }
    </p-step-list>

    <p-step-panels>
      @for (
        step of this.field.fieldGroup;
        track step;
        let index = $index, isFirst = $first, isLast = $last
      ) {
        <p-step-panel [value]="index + 1">
          <ng-template #content let-activateCallback="activateCallback">
            <ng-container
              [ngTemplateOutletContext]="{
                $implicit: step,
                isFirst: isFirst,
                isLast: isLast,
                index: index,
                activateCallback: activateCallback
              }"
              [ngTemplateOutlet]="panelTemplate">
            </ng-container>
          </ng-template>
        </p-step-panel>
      }
    </p-step-panels>
  } @else if (this.props.orientation === 'vertical') {
    @for (
      step of this.field.fieldGroup;
      track step;
      let index = $index, isFirst = $first, isLast = $last
    ) {
      <p-step-item [value]="index + 1">
        <p-step>
          <ng-container
            [ngTemplateOutletContext]="{ $implicit: step }"
            [ngTemplateOutlet]="stepTemplate"></ng-container>
        </p-step>
        <p-step-panel>
          <ng-template #content let-activateCallback="activateCallback">
            <ng-container
              [ngTemplateOutletContext]="{
                $implicit: step,
                isFirst: isFirst,
                isLast: isLast,
                index: index,
                activateCallback: activateCallback
              }"
              [ngTemplateOutlet]="panelTemplate">
            </ng-container>
          </ng-template>
        </p-step-panel>
      </p-step-item>
    }
  }

  <ng-template #stepTemplate let-step>
    <span
      [ngClass]="{ 'text-red-600': (errorCount$(step) | async) || false }"
      class="flex items-center gap-2 whitespace-nowrap py-2 text-lg leading-4">
      {{ transloco(step.props?.label || '') }}
      @if (errorCount$(step) | async) {
        <span class="rounded bg-red-500 px-1 py-1 text-white"
          >{{ (errorCount$(step) | async) || '' }} {{ transloco('error') }}</span
        >
      }
    </span>
  </ng-template>

  <ng-template
    #panelTemplate
    let-activateCallback="activateCallback"
    let-index="index"
    let-isFirst="isFirst"
    let-isLast="isLast"
    let-step>
    @if (this.props.isTopNavigationVisible) {
      <ng-container [ngTemplateOutlet]="navigation"></ng-container>
    }

    <formly-field [field]="step"></formly-field>

    @if (
      this.props.isBottomNavigationVisible === undefined || this.props.isBottomNavigationVisible
    ) {
      <ng-container [ngTemplateOutlet]="navigation"></ng-container>
    }

    <ng-template #navigation>
      <div class="flex justify-between py-4">
        <span>
          @if (!isFirst) {
            <p-button
              (onClick)="activateCallback(index)"
              [label]="transloco('back')"
              icon="pi pi-arrow-left"
              severity="secondary" />
          }
        </span>
        <span>
          @if (!isLast) {
            <p-button
              (onClick)="onNext(step, activateCallback, index + 2)"
              [disabled]="this.errorCount(step) > 0"
              [label]="transloco('continue')"
              icon="pi pi-arrow-right"
              iconPos="right" />
          }
        </span>
      </div>
    </ng-template>
  </ng-template>
</p-stepper>
